@for (toast of toasts.values(); track toast.id) {
  @if (toast.message) {
    <tk-toast [toast]="toast" (dismiss)="dismissToast(toast.id)" />
  }
}
